/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/SplitStringByNewline.ts
 * @create:      2025-07-01 18:00:01.510
 * @modify:      2025-07-11 21:19:12.953
 * @version:     6.0.0
 * @times:       4
 * @lines:       54
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_BREAK_LINE_REGEXP } from "../const/Strings";

/**
 * Splits a given string into an array of substrings based on newline characters.
 * If the input is `undefined`, the function returns `undefined`.
 * 
 * @param data - The string to be split by newline characters. Can be `undefined`.
 * @returns An array of substrings if the input is a string, or `undefined` if the input is `undefined`.
 * 
 * @since 1.0.8
 * @version 2025-06-18
 */
export function SplitStringByNewline(data: string): string[];
export function SplitStringByNewline(data: undefined): undefined;
export function SplitStringByNewline(data?: string): string[] | undefined {
    if (data === undefined) {
        return undefined;
    }

    return data.split(Strings_BREAK_LINE_REGEXP);
}
